export default __webpack_public_path__ + "static/media/danger-circle.c5c15117.svg";